import { render, staticRenderFns } from "./ModalRemuneracaoSuporteEditarHospital.vue?vue&type=template&id=6fa99413&scoped=true"
import script from "./ModalRemuneracaoSuporteEditarHospital.vue?vue&type=script&lang=ts"
export * from "./ModalRemuneracaoSuporteEditarHospital.vue?vue&type=script&lang=ts"
import style0 from "./ModalRemuneracaoSuporteEditarHospital.vue?vue&type=style&index=0&id=6fa99413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa99413",
  null
  
)

export default component.exports